// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__1mcbp","secondary":"Button_secondary__3DqIc","narrow":"Button_narrow__Pg87f","shine":"Button_shine__2qjeC"};